import React, { useRef, useState } from 'react';
import formImg from '../../assets/about/Get-in-touch-img 1.png';
import toast from 'react-hot-toast';
import axios from 'axios';

const FifthCard = () => {
  const initialState = {
    name: '',
    phone: '',
    email: '',
    message: '',
    service: '',
    nameErr: '',
    phoneErr: '',
    emailErr: '',
    serviceErr: '',
    messageErr: ''
  };

  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value, [`${name}Err`]: '' }));
  };

  const clearState = () => setState(initialState);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    const { name, phone, email, service, message } = state;
    let valid = true;

    if (!name.trim()) {
      setState((prev) => ({ ...prev, nameErr: 'Name is required' }));
      valid = false;
    }
    if (!phone || !/^[0-9]{10}$/.test(phone)) {
      setState((prev) => ({ ...prev, phoneErr: 'Please enter a valid 10-digit phone number' }));
      valid = false;
    }
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setState((prev) => ({ ...prev, emailErr: 'Enter valid email' }));
      valid = false;
    }
    if (!service.trim()) {
      setState((prev) => ({ ...prev, serviceErr: 'Service is required' }));
      valid = false;
    }
    if (!message.trim()) {
      setState((prev) => ({ ...prev, messageErr: 'Message is required' }));
      valid = false;
    }

    if (!valid) return;

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/inquiry/create-inquiry`,
        { name, email, phone, service, message },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success('Message sent successfully!');
        clearState();
      }
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      toast.error('Failed to send message. Please try again!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <h1 className="text-[#212121] pb-10 font-bold text-3xl w-full text-center">
        Book a Free Consultation
      </h1>

      <div className="flex flex-col items-center justify-center px-4 md:px-10 mb-10">
        <div className="w-full flex flex-col md:flex-row bg-white shadow-xl rounded-xl overflow-hidden">
          {/* Image */}
          <div className="md:w-1/2 w-full bg-gray-100">
            <img src={formImg} alt="Contact" className="w-full h-full object-cover" />
          </div>

          {/* Form */}
          <div className="md:w-1/2 w-full bg-[#51213D] p-8 text-white">
            <form ref={form} onSubmit={handleSendMessage} className="space-y-5">

              <div>
                <label className="text-sm">Name</label>
                <input
                  type="text"
                  name="name"
                  value={state.name}
                  onChange={handleChange}
                  className="w-full p-2 mt-1 rounded-md bg-white text-black"
                  placeholder="Enter your name"
                />
                {state.nameErr && <p className="text-red-300 text-xs mt-1">{state.nameErr}</p>}
              </div>

              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <label className="text-sm">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                    className="w-full p-2 mt-1 rounded-md bg-white text-black"
                    placeholder="Enter your email"
                  />
                  {state.emailErr && <p className="text-red-300 text-xs mt-1">{state.emailErr}</p>}
                </div>

                <div className="flex-1">
                  <label className="text-sm">Phone No</label>
                  <input
                    type="tel"
                    name="phone"
                    value={state.phone}
                    onChange={handleChange}
                    className="w-full p-2 mt-1 rounded-md bg-white text-black"
                    placeholder="Enter phone number"
                  />
                  {state.phoneErr && <p className="text-red-300 text-xs mt-1">{state.phoneErr}</p>}
                </div>
              </div>

              <div>
                <label className="text-sm">Service</label>
                <input
                  type="text"
                  name="service"
                  value={state.service}
                  onChange={handleChange}
                  className="w-full p-2 mt-1 rounded-md bg-white text-black"
                  placeholder="Enter your service"
                />
                {state.serviceErr && <p className="text-red-300 text-xs mt-1">{state.serviceErr}</p>}
              </div>

              <div>
                <label className="text-sm">Message</label>
                <textarea
                  name="message"
                  rows="4"
                  value={state.message}
                  onChange={handleChange}
                  className="w-full p-2 mt-1 rounded-md bg-white text-black"
                  placeholder="Write your message"
                />
                {state.messageErr && <p className="text-red-300 text-xs mt-1">{state.messageErr}</p>}
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-2 bg-[#FFAC26] hover:bg-[#f08f4e] text-white rounded-md transition-all"
              >
                {loading ? 'Sending...' : 'SUBMIT'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FifthCard;
